import React from "react";
import { Warning } from "@phosphor-icons/react";

// Detect if this bundle is currently talking to the PREVIEW backend.
// If yes, we display a bold ribbon on every page so nobody accidentally
// treats preview as production. Ribbon is hidden on the deployed prod URL.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const IS_PREVIEW = /preview\.emergentagent\.com|localhost/i.test(BACKEND);

export default function PreviewBanner() {
    if (!IS_PREVIEW) return null;
    return (
        <div
            data-testid="preview-banner"
            className="sticky top-0 z-[100] w-full bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-400 text-slate-900 shadow-md"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-1.5 text-center text-[11px] font-semibold sm:text-xs">
                <Warning size={16} weight="fill" className="shrink-0 text-red-700" />
                <span>
                    PREVIEW ENVIRONMENT · This is for testing only. Real business data lives on{" "}
                    <a
                        href="https://teleadmin.in"
                        className="underline decoration-2 underline-offset-2 hover:text-amber-900"
                        rel="noreferrer"
                    >
                        teleadmin.in
                    </a>
                </span>
            </div>
        </div>
    );
}
